<template>
  <div
    class="real-time lg:max-w-4xl mx-auto w-full font-body-medium font-medium sm:font-body-large text-gray-2"
  >
    <div class="px-6 mb-8 mt-20 xs:mt-24 lg:mt-32 text-center">
      <SectionHeader class="mb-2">Real Time Chat</SectionHeader>
      <p>
        Bambee gives you a dedicated HR manager who helps you craft HR policy
        and maintain compliance.
      </p>
    </div>

    <SlideShowMobileChat :chat-data="data" class="mb-40" />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { constants } from '@bambeehr/pollen';
import SlideShowMobileChat from '@/modules/InformationPages/Product/components/Media/SlideShowMobileChat.vue';
import SectionHeader from '@/components/SectionHeader';
import { chatData } from '@/modules/InformationPages/Product/mocks/SplashCopy';

export default defineComponent({
  name: 'SplashRealTime',
  constants,
  components: {
    SectionHeader,
    SlideShowMobileChat,
  },
  setup() {
    const data = chatData;

    return {
      data,
    };
  },
});
</script>
